import { Transform } from 'class-transformer';
import { DateTransform } from '@/utils/value-transformers/date.transform';

export default class ClientManagementModel {
  collectionId!: number;

  managementName!: string;

  representantName!: string;

  managerSituation!: string;

  situation!: string;

  reason!: string;

  observation!: string;

  @Transform(DateTransform)
  representantJustificationDate!: Date;

  representantJustification!: string;

  @Transform(DateTransform)
  managerJustificationDate!: Date;

  needJustification!: boolean;

  managerJustification!: string;

  value!: number;

  quantity!: number;

  terminationDate!: Date;
}
